export namespace ContentRecommendationType {
  export class Enum {
    static readonly ASSESSMENT_COMPETENCE = new Enum('ASSESSMENT_COMPETENCE')
    static readonly COMPANY = new Enum('COMPANY')
    static readonly SKILL = new Enum('SKILL')
    static readonly USER_BASED_CF = new Enum('USER_BASED_CF')

    public constructor(public readonly key: string) {}
  }
}
